export default "__VITE_ASSET__Cr$9LM4U__"